<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content"
                         style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal"
                               v-text="(data ? 'Edit' : 'Add') + ' Distribution'"></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg"
                                     alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content"
                                 style="overflow: visible">
                                <div class="row mt-2 pl-2 pr-2">
                                    <div class="col-md-12">
                                        <TextField
                                            v-model="title"
                                            name="title"
                                            label="Title"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <TextareaField
                                            v-model="description"
                                            name="description"
                                            label="Description (optional)"
                                            rows="5"
                                        />
                                    </div>
                                    <div class="col-md-12 mt-4">
                                        <SelectField
                                            v-model="distribution_type"
                                            name="type"
                                            label="Distribution Type"
                                            :options="types"
                                            :has-icon="true"
                                            :enable-search="false"
                                        >
                                            <template #append-icon>
                                                <a @click.prevent="() => {}">
                                                    <i
                                                        class="fa fa-chevron-circle-down mt-2"
                                                        style="font-size: 20px; color: #40b8dc"
                                                    />
                                                </a>
                                            </template>
                                        </SelectField>
                                    </div>
                                    <div class="col-md-12">
                                        <TextField
                                            v-model="redirect_url"
                                            name="redirect_url"
                                            label="Redirect URL (optional)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-2">
                                    <button v-if="!data" v-text="'Create'"
                                            class="btn-dialog btn-sm ok-btn"
                                            :disabled="!title || !distribution_type"
                                            @click="create">
                                    </button>
                                    <button v-else v-text="'Update'"
                                            class="btn-dialog btn-sm ok-btn"
                                            :disabled="!title || !distribution_type"
                                            @click="update">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from "@/commons/FormElements/TextareaField.vue";
import SelectField from "@/commons/FormElements/SelectField.vue";
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";

export default {
    name: "ModalAddEditDistribution",
    components: {SelectField, TextareaField, TextField},
    props: {
        campaignId: String,
        data: {
            type: Object,
            default: null
        },
        types: Array
    },
    data() {
        return {
            title: '',
            description: '',
            distribution_type: '',
            redirect_url: '',
        }
    },
    created() {
        if (this.data) {
            this.title = this.data.title;
            this.description = this.data.description;
            this.distribution_type = this.data.type.toString();
            this.redirect_url = this.data.redirect_url;
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        create() {
            if (this.distribution_type === '1') {
                return this.$emit('upload', {
                    title: this.title,
                    description: this.description,
                    type: this.distribution_type,
                    redirect_url: this.redirect_url,
                })
            }
            const params = {
                '#request': DibbleApi.api.createDistribution,
                campaign_id: this.campaignId,
                title: this.title,
                description: this.description,
                type: this.distribution_type,
                redirect_url: this.redirect_url,
            }

            DibbleJs.showLoader();
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Create distribution successfully');
                    this.$emit('success')
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        update() {
            const params = {
                '#request': DibbleApi.api.updateDistribution,
                distribution_id: this.data.distribution_id,
                title: this.title,
                description: this.description,
                type: this.distribution_type,
                redirect_url: this.redirect_url,
            }

            DibbleJs.showLoader();
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Update distribution successfully');
                    this.$emit('success')
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
</style>
